import store from "@/store/index"
import { getAllDepartmentList } from "@/api/api-module-data"

export default {
  data() {
    return {
      fetchingAllDepartments: false,
      ongoingApiCallPromise: null,
    }
  },

  methods: {
    async getAllDepartmentFromApiAndStoreVuex() {
      if (this.fetchingAllDepartments) {
        // If there's already an ongoing API call, wait for it to complete
        await this.ongoingApiCallPromise
        return // Return early as the data will be fetched by the ongoing call
      }

      try {
        this.fetchingAllDepartments = true //

        const response = await getAllDepartmentList()

        if (response) {
          store.dispatch(
            "appPermission/setInternalAllDepartment",
            response.data
          )
        }
      } catch (error) {
        console.error("Error fetching department list from API", error)
      } finally {
        this.fetchingAllDepartments = false
        this.ongoingApiCallPromise = null
      }
    },

    async getAllDepartmentListFromVuex() {
      if (
        !store.state.appPermission?.internalAllDepartment?.length &&
        !this.fetchingAllDepartments
      ) {
        // If data doesn't exist in Vuex and no ongoing call, initiate API call
        this.ongoingApiCallPromise = this.getAllDepartmentFromApiAndStoreVuex()
        await this.ongoingApiCallPromise
      } else if (this.fetchingAllDepartments) {
        // Wait for ongoing API call to complete before using data from Vuex
        await this.ongoingApiCallPromise
      }

      return store.state.appPermission.internalAllDepartment || []
    },

    async getDepartmentOptionByDepartmentId(departmentId) {
      let departmentList = await this.getAllDepartmentListFromVuex()
      let targetDepartment = departmentList
        .filter((item) => {
          return item.departmentId === departmentId
        })
        .map((item) => {
          return {
            departmentId: item.departmentId,
            departmentName: item.departmentName,
          }
        })[0]

      return targetDepartment || null
    },

    async getSiteAndDepartmentNameByDepartmentIdList(departmentIdList) {
      let departmentList = await this.getAllDepartmentListFromVuex()
      let siteAndDepartmentName = departmentList
        .filter((item) => {
          return departmentIdList.some((departmentId) => {
            return item.departmentId === departmentId
          })
        })
        .map((item) => {
          return {
            siteName: item.siteName,
            departmentName: item.departmentName,
          }
        })

      return siteAndDepartmentName
    },

    async getSingleSiteNameBySiteId(siteId) {
      let siteList = store.getters["siteStore/siteOptions"]

      let targetIndex = siteList.findIndex((item) => item.value === siteId)

      return siteList?.[targetIndex]?.text || null
    },
  },
}
